import { ref, watchEffect } from 'vue';

// Helferfunktion, um das initiale Theme zu bestimmen.
function getInitialTheme() {
  const storedTheme = localStorage.getItem('theme');
  // Wenn ein explizites Theme (light/dark) gespeichert ist, wird dieses verwendet.
  if (storedTheme === 'light' || storedTheme === 'dark') {
    return storedTheme;
  }
  // Andernfalls wird das System-Theme als Standard verwendet.
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function useTheme() {
  // Initialisiert das Theme basierend auf dem gespeicherten Wert oder der Systemeinstellung.
  const theme = ref(getInitialTheme());

  const applyTheme = (newTheme) => {
    const body = document.body;
    if (newTheme === 'dark') {
      body.classList.add('dark-theme');
    } else {
      body.classList.remove('dark-theme');
    }
  };

  // Dieser Watcher reagiert auf Änderungen des `theme`-Zustands (und läuft einmal initial),
  // speichert die neue Wahl im localStorage und wendet die entsprechende CSS-Klasse an.
  watchEffect(() => {
    localStorage.setItem('theme', theme.value);
    applyTheme(theme.value);
  });

  // Vereinfachte Funktion, die nur noch zwischen 'light' und 'dark' umschaltet.
  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
  };

  return { theme, toggleTheme };
}